import { PostArenaSubmissionPresenter } from '@/presentation/presenters/arena/postArenaSubmissionPresenter'
import { PostArenaSubmissionViewModel } from '@/presentation/viewmodels/arena/postArenaSubmissionViewModel'

export function usePostArenaSubmissionPresenter(
  presenter: PostArenaSubmissionPresenter = new PostArenaSubmissionPresenter(new PostArenaSubmissionViewModel())
) {
  return {
    judgeToken: presenter.judgeToken,
    isLoading: presenter.isLoading,
    error: presenter.error,
    postArenaSubmission: presenter.postArenaSubmission.bind(presenter)
  }
}
